module.exports = __webpack_public_path__ + "static/media/Food delivery.f9c8663c.png";